import { render, staticRenderFns } from "./WizardNavigation.vue?vue&type=template&id=6b726bae&scoped=true&lang=pug&"
import script from "./WizardNavigation.vue?vue&type=script&lang=ts&"
export * from "./WizardNavigation.vue?vue&type=script&lang=ts&"
import style0 from "./WizardNavigation.vue?vue&type=style&index=0&id=6b726bae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b726bae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\as3-portals\\AS3.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b726bae')) {
      api.createRecord('6b726bae', component.options)
    } else {
      api.reload('6b726bae', component.options)
    }
    module.hot.accept("./WizardNavigation.vue?vue&type=template&id=6b726bae&scoped=true&lang=pug&", function () {
      api.rerender('6b726bae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/components/WizardNavigation.vue"
export default component.exports